import { Col } from "@amzn/stencil-react-components/layout";
import { Link } from "@amzn/stencil-react-components/link";
import { Text } from "@amzn/stencil-react-components/text";
import React, { FC } from "react";
import { getString } from "@/common/uistringlabels/ui-string-utils";
import { CHOOSE_DELIVERY_STRINGS } from "../choose-delivery.constants";

export interface DeliveryOptionsEmptyProps {
  supportTicketHref: string;
}

export const DeliveryOptionsEmpty: FC<DeliveryOptionsEmptyProps> = ({ supportTicketHref }) => (
  <Col gridGap="S300" data-testid="delivery-options-empty">
    <Text>{getString(`${CHOOSE_DELIVERY_STRINGS}.empty`)}</Text>
    <Link href={supportTicketHref} target="_blank" rel="noopener noreferrer">
      {getString("replacement.chooseDevice.generateSupportTicket")}
    </Link>
  </Col>
);
